import { deflate, inflate } from 'pako';
import { ExportDetails } from '../chat-conversation';

export function base64EncodeBinary(data: Uint8Array): string {
  return btoa(String.fromCharCode(...data));
}

export function base64DecodeBinary(base64: string): Uint8Array {
  const binary = atob(base64);
  return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

export async function encodeExportDetails(data: ExportDetails): Promise<string> {
  const json = JSON.stringify(data);
  const encoder = new TextEncoder();
  const encodedData = encoder.encode(json);

  const compressedData = deflate(encodedData);
  const base64 = base64EncodeBinary(compressedData);
  return encodeURIComponent(base64);
}

export async function decodeExportDetails(encodedValue: string): Promise<ExportDetails> {
  const base64 = decodeURIComponent(encodedValue);
  const compressedData = base64DecodeBinary(base64);

  const decompressed = inflate(compressedData);
  const decodedText = new TextDecoder().decode(decompressed);
  return JSON.parse(decodedText);
}
